import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { UniqaSyncJobDetailResponse } from '../definitions/uniqa-sync-job-detail-response.interface';

@Injectable()
export class GetUniqaSyncJobByIdService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public detail(id: string): Observable<UniqaSyncJobDetailResponse> {
    const url = `${this.configService.config.rest.apiV2Url}/uniqa-sync-jobs/${id}`;

    return this.client.get<UniqaSyncJobDetailResponse>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
